import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

export const PostList = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("t");
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getData();
  }, [currentPage, keyword]);

  const getData = () => {
    axios
      .get("/post/public/shows", {
        params: {
          page: currentPage,
          limit: 8,
          topicSlug: keyword,
        },
      })
      .then((res) => {
        const postData = res.data.data?.posts;
        const total = res.data.data?.totalPages;
        setPosts(postData);
        setTotalPages(total);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <a className="breadcrumb-item text-dark" href="#">
                Trang chủ
              </a>
              <span className="breadcrumb-item active">Tin tức</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <h2 className="section-title position-relative text-uppercase mx-xl-5 mb-5">
          <span className="bg-secondary pr-3">Danh sách tin tức</span>
        </h2>
        <div className="row px-xl-5">
          {posts.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <Link to={item.slug} style={{ textDecoration: "none" }}>
                <div className="bg-light border rounded h-100 overflow-hidden">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="img-fluid w-100"
                    style={{ objectFit: "cover", height: "180px" }}
                  />
                  <div className="p-3">
                    <h5>{item.title}</h5>
                    <p className="text-muted mb-0 post-description">
                      {item.short_description}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <nav
          aria-label="Page navigation"
          className="d-flex justify-content-center mt-4"
        >
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage > 1) setCurrentPage(currentPage - 1);
                }}
              >
                &laquo;
              </a>
            </li>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <li
                key={page}
                className={`page-item ${currentPage === page ? "active" : ""}`}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentPage(page);
                  }}
                >
                  {page}
                </a>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === totalPages && "disabled"
              }`}
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                }}
              >
                &raquo;
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};
